import React from 'react'
import { t } from "i18next";
import { useDispatch } from 'react-redux';
import { setAmount } from './Redux/shoppingCartReducer';

function QuantityButtons({ addItemToCart, removeItemFromCart, itemsCount, product }) {
    const dispatch = useDispatch();
    return (
        <div>
            <button aria-label={`${t("quantity")} ${itemsCount} ${"add"}`} onClick={() => addItemToCart()}>+</button>
            <input type="number" className="qty-input" value={Number(itemsCount).toString()} onChange={e => dispatch(setAmount({ selectedProduct: product, qty: e.target.value }))} />
            <button aria-label={`${t("quantity")} ${itemsCount} ${"remove"}`} onClick={() => removeItemFromCart()}>-</button>
        </div>
    )
}

export default QuantityButtons